// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"662":"7048bc31a27026fa","888":"5963df7efb6d0d42"}[chunkId] + ".css";
};